<!-- Banner Section -->
<div class="collab-banner sticky-header-banner banner-sec">
    <div class="container">
        <div class="sec-padding m-col-width mt-negative pb-0">
            <div class="text-center z-index pb-2">

                <div class="mx-auto whats-new-label transparent-bg">
                    <div class="wave-container">
                        <div class="wave-dot wave-dot-1"></div> 
                        <div class="wave-dot wave-dot-3"></div> 
                    </div> 
                    <span class="paragraph-global-text sub-head-paragraph">
                        {{'softwareServices.banner.preTitle' | translate}}
                    </span>
                </div>

                <h1 class="banner-heading mx-auto mw-800">{{'softwareServices.banner.title' | translate}}</h1>
                <p class="paragraph-global-text mw-650">{{'softwareServices.banner.description' | translate}}</p>
                <div class="mt-5 mb-5 mx-auto button-container align-items-start">
                    <a class="save-btn cfa btn" [href]="signUrl+'get-started/u/setup-profile?returnUrl=amy'" target="_blank">
                        {{'softwareServices.banner.btnText' | translate}}    
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Services Section -->
<div class="sec-padding">
    <div class="container">
        <div class="sec-title pb-3 mb-5 text-center">
            <h2 class="heading-one mx-auto"> {{'softwareServices.services.title' | translate}}</h2>
            <p class="paragraph-global-text sub-head-paragraph mw-800 mb-0">{{'softwareServices.services.description' | translate}}</p>
        </div>
        <div class="row">
            <!-- Custom Software Development -->
            <div class="col-lg-4 col-md-6 col-sm-12 pt-4">
                <div class="card why-amy-cards">
                    <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-code-xml icon-primary-color"><path d="m18 16 4-4-4-4"/><path d="m6 8-4 4 4 4"/><path d="m14.5 4-5 16"/></svg>
                     </div>
                    <h4 class="heading-three">{{'softwareServices.services.section1.title' | translate}}</h4>
                    <p class="paragraph-global-text">{{'softwareServices.services.section1.description' | translate}}</p>
                    <ul class="disc-list">
                        <li class="paragraph-global-text">{{'softwareServices.services.section1.point1' | translate}}</li>
                        <li class="paragraph-global-text">{{'softwareServices.services.section1.point2' | translate}}</li>
                        <li class="paragraph-global-text">{{'softwareServices.services.section1.point3' | translate}}</li>
                        <li class="paragraph-global-text">{{'softwareServices.services.section1.point4' | translate}}</li>
                        <li class="paragraph-global-text">{{'softwareServices.services.section1.point5' | translate}}</li>
                    </ul>
                </div>
            </div>
            <!-- Cloud Services & DevOps -->
            <div class="col-lg-4 col-md-6 col-sm-12 pt-4">
                <div class="card why-amy-cards">
                    <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-cloud icon-primary-color"><path d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z"/></svg>
                     </div>
                    <h4 class="heading-three">{{'softwareServices.services.section2.title' | translate}}</h4>
                    <p class="paragraph-global-text">{{'softwareServices.services.section2.description' | translate}}</p>
                    <ul class="disc-list">
                        <li class="paragraph-global-text">{{'softwareServices.services.section2.point1' | translate}}</li>
                        <li class="paragraph-global-text">{{'softwareServices.services.section2.point2' | translate}}</li>
                        <li class="paragraph-global-text">{{'softwareServices.services.section2.point3' | translate}}</li>
                        <li class="paragraph-global-text">{{'softwareServices.services.section2.point4' | translate}}</li>
                        <li class="paragraph-global-text">{{'softwareServices.services.section2.point5' | translate}}</li>
                    </ul>
                </div>
            </div>
            <!-- AI & ML -->
            <div class="col-lg-4 col-md-6 col-sm-12 pt-4">
                <div class="card why-amy-cards">
                    <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-brain  icon-primary-color"><path d="M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z"/><path d="M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z"/><path d="M15 13a4.5 4.5 0 0 1-3-4 4.5 4.5 0 0 1-3 4"/><path d="M17.599 6.5a3 3 0 0 0 .399-1.375"/><path d="M6.003 5.125A3 3 0 0 0 6.401 6.5"/><path d="M3.477 10.896a4 4 0 0 1 .585-.396"/><path d="M19.938 10.5a4 4 0 0 1 .585.396"/><path d="M6 18a4 4 0 0 1-1.967-.516"/><path d="M19.967 17.484A4 4 0 0 1 18 18"/></svg>
                     </div>
                    <h4 class="heading-three">{{'softwareServices.services.section3.title' | translate}}</h4>
                    <p class="paragraph-global-text">{{'softwareServices.services.section3.description' | translate}}</p>
                    <ul class="disc-list">
                        <li class="paragraph-global-text">{{'softwareServices.services.section3.point1' | translate}}</li>
                        <li class="paragraph-global-text">{{'softwareServices.services.section3.point2' | translate}}</li>
                        <li class="paragraph-global-text">{{'softwareServices.services.section3.point3' | translate}}</li>
                        <li class="paragraph-global-text">{{'softwareServices.services.section3.point4' | translate}}</li>
                        <li class="paragraph-global-text">{{'softwareServices.services.section3.point5' | translate}}</li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12 pt-4">
                <div class="card why-amy-cards">
                    <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shield icon-primary-color"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/></svg>
                     </div>
                    <h4 class="heading-three">{{'softwareServices.services.section4.title' | translate}}</h4>
                    <p class="paragraph-global-text">{{'softwareServices.services.section4.description' | translate}}</p>
                    <ul class="disc-list">
                        <li class="paragraph-global-text">{{'softwareServices.services.section4.point1' | translate}}</li>
                        <li class="paragraph-global-text">{{'softwareServices.services.section4.point2' | translate}}</li>
                        <li class="paragraph-global-text">{{'softwareServices.services.section4.point3' | translate}}</li>
                        <li class="paragraph-global-text">{{'softwareServices.services.section4.point4' | translate}}</li>
                        <li class="paragraph-global-text">{{'softwareServices.services.section4.point5' | translate}}</li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12 pt-4">
                <div class="card why-amy-cards">
                    <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-test-tube icon-primary-color"><path d="M14.5 2v17.5c0 1.4-1.1 2.5-2.5 2.5c-1.4 0-2.5-1.1-2.5-2.5V2"/><path d="M8.5 2h7"/><path d="M14.5 16h-5"/></svg>
                     </div>
                    <h4 class="heading-three">{{'softwareServices.services.section5.title' | translate}}</h4>
                    <p class="paragraph-global-text">{{'softwareServices.services.section5.description' | translate}}</p>
                    <ul class="disc-list">
                        <li class="paragraph-global-text">{{'softwareServices.services.section5.point1' | translate}}</li>
                        <li class="paragraph-global-text">{{'softwareServices.services.section5.point2' | translate}}</li>
                        <li class="paragraph-global-text">{{'softwareServices.services.section5.point3' | translate}}</li>
                        <li class="paragraph-global-text">{{'softwareServices.services.section5.point4' | translate}}</li>
                        <li class="paragraph-global-text">{{'softwareServices.services.section5.point5' | translate}}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="sec-padding how-it-works-section sec-secondary-background">
    <div class="container">
        <div class="sec-title pb-3 mb-5 text-center">
            <h2 class="heading-one mx-auto"> {{"softwareServices.howItWorks.title" | translate}}</h2>
        </div>

        <div class="grid-container">
            
            <div class="card">
              <div class="card-content">
                <div class="text-center">
                  <h3>{{"softwareServices.howItWorks.section1.title" | translate}}</h3>
                  <p>{{"softwareServices.howItWorks.section1.description" | translate}}</p>
                </div>
              </div>
              <div class="arrow-top">
                <svg width="94px" height="94px" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#5F54EE"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M56 270.5C56 256.429 79.5553 218.859 120.902 197.186C162.249 175.512 194.07 164.5 242.113 164.5C274.142 164.5 306.771 175.395 340 197.186" stroke="#5F54EE" stroke-opacity="0.9" stroke-width="8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="16 32"></path> <path d="M325.63 129C337.877 172.588 344 195.072 344 196.45C344 198.518 308.436 212.998 292 235" stroke="#5F54EE" stroke-opacity="0.9" stroke-width="8" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>                             
              </div>
            </div>
          
            
            <div class="card">
              <div class="card-content">
                <div class="text-center">
                    <h3>{{"softwareServices.howItWorks.section2.title" | translate}}</h3>
                    <p>{{"softwareServices.howItWorks.section2.description" | translate}}</p>
                </div>
              </div>
              <div class="arrow-bottom">
                <svg width="94px" height="94px" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#5F54EE" transform="matrix(1, 0, 0, -1, 0, 0)rotate(0)"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M56 270.5C56 256.429 79.5553 218.859 120.902 197.186C162.249 175.512 194.07 164.5 242.113 164.5C274.142 164.5 306.771 175.395 340 197.186" stroke="#5F54EE" stroke-opacity="0.9" stroke-width="8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="16 32"></path> <path d="M325.63 129C337.877 172.588 344 195.072 344 196.45C344 198.518 308.436 212.998 292 235" stroke="#5F54EE" stroke-opacity="0.9" stroke-width="8" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
              </div>
            </div>
          
          
            <div class="card">
              <div class="card-content">
                <div class="text-center">
                    <h3>{{"softwareServices.howItWorks.section3.title" | translate}}</h3>
                    <p>{{"softwareServices.howItWorks.section3.description" | translate}}</p>
                </div>
              </div>
              <div class="arrow-top">
                <svg width="94px" height="94px" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#5F54EE"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M56 270.5C56 256.429 79.5553 218.859 120.902 197.186C162.249 175.512 194.07 164.5 242.113 164.5C274.142 164.5 306.771 175.395 340 197.186" stroke="#5F54EE" stroke-opacity="0.9" stroke-width="8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="16 32"></path> <path d="M325.63 129C337.877 172.588 344 195.072 344 196.45C344 198.518 308.436 212.998 292 235" stroke="#5F54EE" stroke-opacity="0.9" stroke-width="8" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
              </div>
            </div>
          
            
            <div class="card">
              <div class="card-content">
                <div class="text-center">
                    <h3>{{"softwareServices.howItWorks.section4.title" | translate}}</h3>
                    <p>{{"softwareServices.howItWorks.section4.description" | translate}}</p>
                </div>
              </div>
            </div>
          </div>
    </div>
</div>


<!-- pricing  section-->
<div class="sec-padding pricing-section">
    <div class="container position-relative">
        <div class="sec-title pb-3 text-center">
            <h2 class="heading-one mx-auto mw-800">{{"softwareServices.pricing.title" | translate}} </h2>
            <p class="paragraph-global-text mw-900 sub-head-paragraph mx-auto pb-0">{{"softwareServices.pricing.description" | translate}}</p>
        </div>     
    </div>
     <!-- packages listing -->
     <app-packages [showListing]="true" [hideBanner]="true"></app-packages>
</div>


<div class="sec-padding sec-secondary-background">
    <div class="container">
        <div class="sec-title pb-3 mb-5 text-center">
            <h2 class="heading-one mx-auto mw-800"> {{"softwareServices.whyChooseUs.title" | translate}}</h2>
        </div>
        <div class="row">
            <div class="col-lg-3 col-md-6 col-sm-12 pt-4">
                <div class="card why-amy-cards">
                     <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-star icon-primary-color"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"/></svg>
                     </div>
                     <h4 class="heading-three pt-1">{{'softwareServices.whyChooseUs.section1.title' | translate}}</h4>
                     <p class="paragraph-global-text sub-head-paragraph mw-300 mb-0">{{'softwareServices.whyChooseUs.section1.description' | translate}}</p>
                </div>
             </div>
             <div class="col-lg-3 col-md-6 col-sm-12 pt-4">
                <div class="card why-amy-cards">
                    <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-brain icon-primary-color"><path d="M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z"/><path d="M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z"/><path d="M15 13a4.5 4.5 0 0 1-3-4 4.5 4.5 0 0 1-3 4"/><path d="M17.599 6.5a3 3 0 0 0 .399-1.375"/><path d="M6.003 5.125A3 3 0 0 0 6.401 6.5"/><path d="M3.477 10.896a4 4 0 0 1 .585-.396"/><path d="M19.938 10.5a4 4 0 0 1 .585.396"/><path d="M6 18a4 4 0 0 1-1.967-.516"/><path d="M19.967 17.484A4 4 0 0 1 18 18"/></svg>
                    </div>
                     <h4 class="heading-three pt-1">{{'softwareServices.whyChooseUs.section2.title' | translate}}</h4>
                     <p class="paragraph-global-text sub-head-paragraph mw-300 mb-0">{{'softwareServices.whyChooseUs.section2.description' | translate}}</p>
                </div>
             </div>
             <div class="col-lg-3 col-md-6 col-sm-12 pt-4">
                <div class="card why-amy-cards">
                    <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-dollar-sign icon-primary-color"><line x1="12" x2="12" y1="2" y2="22"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
                    </div>
                     <h4 class="heading-three pt-1">{{'softwareServices.whyChooseUs.section3.title' | translate}}</h4>
                     <p class="paragraph-global-text sub-head-paragraph mw-300 mb-0">{{'softwareServices.whyChooseUs.section3.description' | translate}}</p>
                </div>
             </div>
             <div class="col-lg-3 col-md-6 col-sm-12 pt-4">
                <div class="card why-amy-cards">
                    <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shield icon-primary-color"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/></svg>
                    </div>
                     <h4 class="heading-three pt-1">{{'softwareServices.whyChooseUs.section4.title' | translate}}</h4>
                     <p class="paragraph-global-text sub-head-paragraph mw-300 mb-0">{{'softwareServices.whyChooseUs.section4.description' | translate}}</p>
                </div>
             </div>
        </div>
    </div>
</div>

<div class="sec-padding testimonials-sec">
    <div class="container">
        <div class="sec-title pb-3 mb-5 text-center">
            <h2 class="heading-one mx-auto mw-800">{{"softwareServices.testimonials.title" | translate}}</h2>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 pt-4">
                <div class="card why-amy-cards reviews">
                   <div>
                        <div class="d-flex align-items-center mb-4 w-100">
                            <app-start-rating-readonly [rating]="rating1"></app-start-rating-readonly>                          
                            <span class="ml-2 sub-heading-color">{{rating1 | number: '1.1-1' }}</span>
                        </div>
                        <p class="paragraph-global-text sub-head-paragraph mw-300 mb-0">“{{'softwareServices.testimonials.section1.quote' | translate}}”</p>
                   </div>
                     <div class="d-flex align-items-center mt-3">
                        <div>
                            <h6 class="card-title mb-1">{{'softwareServices.testimonials.section1.name' | translate}}</h6>
                            <span class="sub-heading-color">{{'softwareServices.testimonials.section1.role' | translate}}</span>
                        </div>
                     </div>
                </div>
             </div>
             <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 pt-4">
                <div class="card why-amy-cards reviews">
                    <div>
                        <div class="d-flex align-items-center mb-4 w-100">
                            <app-start-rating-readonly [rating]="rating2"></app-start-rating-readonly>                          
                            <span class="ml-2 sub-heading-color">{{rating2 | number: '1.1-1' }}</span>
                        </div>
                         <p class="paragraph-global-text sub-head-paragraph mw-300 mb-0">“{{'softwareServices.testimonials.section2.quote' | translate}}”</p>
                    </div>
                     <div class="d-flex align-items-center mt-3">
                        <div class="">
                            <h6 class="card-title mb-1">{{'softwareServices.testimonials.section2.name' | translate}}</h6>
                            <span class="sub-heading-color">{{'softwareServices.testimonials.section2.role' | translate}}</span>
                        </div>
                     </div>
                </div>
             </div>
             <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 pt-4">
                <div class="card why-amy-cards reviews">
                    <div>
                        <div class="d-flex align-items-center mb-4 w-100">
                            <app-start-rating-readonly [rating]="rating3"></app-start-rating-readonly>                          
                            <span class="ml-2 sub-heading-color">{{rating3 | number: '1.1-1' }}</span>
                        </div>
                         <p class="paragraph-global-text sub-head-paragraph mw-300 mb-0">“{{'softwareServices.testimonials.section3.quote' | translate}}”</p>
                    </div>
                     <div class="d-flex align-items-center mt-3">
                        <div class="">
                            <h6 class="card-title mb-1">{{'softwareServices.testimonials.section3.name' | translate}}</h6>
                            <span class="sub-heading-color">{{'softwareServices.testimonials.section3.role' | translate}}</span>
                        </div>
                     </div>
                </div>
             </div>
        </div>
    </div>
</div>

<!-- Call to Action -->
<div class="sec-padding cfa-sec position-relative">
      <div class="cfa-grid"></div>
    <div class="container z-index">
        <div class="sec-title text-center">
            <h2 class="heading-one text-white mx-auto">{{'softwareServices.cfa.title' | translate}}</h2>
            <p class="paragraph-global-text sub-head-paragraph mw-900 text-white">{{'softwareServices.cfa.description' | translate}}</p>
            <div class="button-container mt-4">
                <a class="save-btn cfa btn mx-auto fw-500 " [routerLink]="['/en/book-demo']" target="_blank">
                    {{'softwareServices.cfa.btnText' | translate}}
                </a>
            </div>
        </div>
    </div>
</div>
